<template>
    <div class="animated fadeIn">
     
      <b-row>
        <b-col sm="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
                <b-row>
                    <b-col>
                        <strong> Part B Vehicle Updation </strong> 
                    </b-col>
                    <b-col>
                        <strong style="float: right;"> Date : {{date}} </strong> 
                    </b-col>
                </b-row>
                
  
            </div>
            <b-row>
             <b-col md="12" >
      
             <div>
              <ul class="nav nav-tabs nav-justified">
                <li class="nav-item">
                    <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">Part-B Vehicle Updating Today</a>
                </li>

                <li class="nav-item">
                    <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Part-B Vehicle Updated Today</a>
                </li> 
                <li class="nav-item">
                    <a @click="activeTab = 2"  class="nav-link" :class="{'active' : isActiveTab(2)}" >Part-B Vehicle Updation failed</a>
                </li> 
               
              </ul>
            </div>
             
            </b-col>
            <b-col md="12" >
          
              <div class="tab-panel" v-if="isActiveTab(0)">
                <vehicle_updating_today></vehicle_updating_today>
              </div>
  
              <div class="tab-panel" v-if="isActiveTab(1)">
                <vehicle_updated_today></vehicle_updated_today>
              </div>
              <div class="tab-panel" v-if="isActiveTab(2)">
                <vehicle_updation_failed></vehicle_updation_failed>
              </div>
             </b-col>
            </b-row> 
          </b-card>
         
        </b-col>
      </b-row> 
    </div>   
  </template>
  <script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";

  import vehicle_updating_today from './vehicleUpdatingToday.vue'
  import vehicle_updated_today from './vehicleUpdatedToday.vue'
  import vehicle_updation_failed from './vehicleUpdationFailed.vue'

  export default {
    data: function() {
      return {
        activeTab: 0,
        vehicle_updating_today,
        vehicle_updated_today,
        vehicle_updation_failed,
        date :'',
      };
    },
    components: {
        vehicle_updating_today,
        vehicle_updated_today,
        vehicle_updation_failed,
    },
    created: function() {
      this.isActiveTab(0);
      this.todaydate();
    },
    methods: {
        isActiveTab(id)
        {
            return this.activeTab === id
        },

        todaydate (){
            var today = new Date();
            // Current Date
            this.date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

            console.log("date",this.date)

        },
    }
  };
  </script>
  